import React from 'react';
import PropTypes from 'prop-types';
import './style.css';
import Button from 'new-ui/Components/Button';

const WidgetBtn = ({ title, onClick }) => (
  <Button
    backgroundColor="#213332"
    color="#FFF"
    width="250px"
    className="widget-btn"
    title={title}
    action={onClick}
  />
);

WidgetBtn.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default WidgetBtn;
